<template>
  <div>
    <b-row>
      <b-col class="col-12" v-if="this.defaultValues.maxDate">
        <filters :monthPrecise="defaultValues" @refresh="refresh" :dataSource="$t('filter.sourceMobilityInsights')"
          :mipFaq="true" :weekdaysFilter="true" />
      </b-col>
    </b-row>
    <div v-if="this.apiError">
      <b-alert show variant="danger">{{
        $t("mip.no_access_territory")
      }}</b-alert>
    </div>
    <div v-if="searchDone">
      <api-error v-if="apiError" />
      <loading v-else-if="!indicators.kpisTable.items" />
      <div v-else>
        <b-row>
          <b-col class="col-12 text-right">
            <!--<a @click="mipReportExport" class="btn btn-primary" target="_blank">
                  <font-awesome-icon icon="file-excel" class="mr-2" />
                  {{ $t('general.exportReportExcel') }}
                </a>
                <b-btn @click="generateReport" variant="primary">
                  <font-awesome-icon icon="file-pdf" class="mr-2" />
                  {{ $t('general.exportReportPDF') }}
                </b-btn>-->
          </b-col>
        </b-row>
        <div class="mt-3">
          <b-row class="mt-3">
            <b-col class="col-12 text-right">
              <!--<a @click="mipReportExport" class="btn btn-primary" target="_blank">
                  <font-awesome-icon icon="file-excel" class="mr-2" />
                  {{ $t('general.exportReportExcel') }}
                </a>
                <b-btn @click="generateReport" variant="primary">
                  <font-awesome-icon icon="file-pdf" class="mr-2" />
                  {{ $t('general.exportReportPDF') }}
                </b-btn>-->
            </b-col>
          </b-row>
          <b-tabs fill class="mt-3">
            <!-- KPIS -->
            <b-tab active>
              <template #title>
                <span>
                  <font-awesome-icon :icon="['fas', 'tachometer-alt']" /> {{ $t('general.kpis') }}
                </span>
              </template>

              <MipKPIS
                v-if="this.indicators.topFiveCountries && this.topFiveCountries && this.indicators.male_percent && this.indicators.kpis.dayTrippers.value"
                :topFiveCountries="this.indicators.topFiveCountries" :male_percent="this.indicators.male_percent"
                :female_percent="this.indicators.female_percent" :ageGroups="this.indicators.ageGroups"
                :topFiveCountriesData="this.topFiveCountries" :dwellTimes="this.indicators.dwellTimes"
                :hourlyVisitors="this.indicators.hourlyVisitors" :kpis="this.indicators.kpis"
                :territoryName="this.territoryName" />
            </b-tab>

            <!-- details table -->
            <b-tab>
              <template #title>
                <span>
                  <font-awesome-icon :icon="['fas', 'table']" />
                  {{ $t("mip.tabs.detailsTable") }}
                </span>
              </template>

              <DetailsTable v-if="this.indicators.kpisTable" :tableData="this.indicators.kpisTable" @download="download" />
            </b-tab>

            <!-- Total visitors -->
            <b-tab>
              <template #title>
                <span>
                  <font-awesome-icon :icon="['fas', 'users']" />
                  {{ $t("mip.tabs.totalVisitors") }}
                </span>
              </template>

              <b-row class="mt-3 col-12">
                <b-col class="col-6">
                  <b-row>
                    <b-col v-if="this.indicators.kpis.totalVisitors.evo_real">
                      <SimpleEvoCard :title="$t('indicators.totalVisitors')"
                        :value="this.indicators.kpis.totalVisitors.value" :evoReal="indicators.kpis.totalVisitors.evo_real"
                        :evoPercent="indicators.kpis.totalVisitors.evoPercent" :period_info="$t('dashboard.provenance.caption')" />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mt-3" v-if="this.indicators.visitorsRepart.data">
                      <ChartCard ChartCard :title="$t('indicators.mainProvenances')"
                        :options="this.indicators.visitorsRepart.options" :data="this.indicators.visitorsRepart.data"
                        :chartType="this.indicators.visitorsRepart.type" />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="col-lg-6 col-12 mt-3">
                  <b-row>
                    <b-col>
                      <WeekdayChartCard v-if="this.indicators.dayOfWeek.data"
                        :title="$t('indicators.totalVisitorsByDayOfWeek')" :options="this.indicators.dayOfWeek.options"
                        :data="this.indicators.dayOfWeek.data" :chartType="this.indicators.dayOfWeek.type"
                        defaultIndicator="totalVisitors" />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="col-12">
                <b-col class="col-lg-6 col-12 mt-3" v-if="this.indicators.topCountries.table">
                  <TableCard :filter="true" :filter_title="$t('mip.mip_filter_swiss')"
                    :title="this.indicators.topCountries.title" :table="this.indicators.topCountries.table"
                    :header="this.indicators.topCountries.fields" @input="filterCountry" :searchFunction="true"
                    :bubble="this.$t('mip.dataProtection_provenance')" :downloadable="true"
                    @download="ExportProvenances" :period_info="$t('dashboard.provenance.caption')" />
                </b-col>
                <b-col class="col-lg-6 col-12 mt-3" v-if="this.indicators.topCantons.table">
                  <TableCard :filter="true" :filter_title="$t('mip.mip_filter_canton')"
                    :title="this.indicators.topCantons.title" :table="this.indicators.topCantons.table"
                    :header="this.indicators.topCantons.fields" :searchFunction="true" @input="filterCanton"
                    :bubble="this.$t('mip.dataProtection_provenance')" :downloadable="true"
                    @download="ExportProvenances" :period_info="$t('dashboard.provenance.caption')" />
                </b-col>
                <b-col class="mt-3 col-12 mt-3" v-if="this.indicators.topMunicipalities.table">
                  <TableCard :filter="true" :filter_title="$t('mip.mip_filter_canton')"
                    :title="this.indicators.topMunicipalities.title" :table="this.indicators.topMunicipalities.table"
                    :header="this.indicators.topMunicipalities.fields" :searchFunction="true" @input="filterCanton"
                    modalId="modalMuniTotalMap" @displayModal="displayModal" :pagination="true" :downloadable="true"
                    @download="ExportProvenances" :bubble="this.$t('mip.dataProtection_provenance')" :period_info="$t('dashboard.provenance.caption')" />
                </b-col>
              </b-row>
            </b-tab>

            <!-- Overnights only -->
            <b-tab>
              <template #title>
                <span>
                  <font-awesome-icon :icon="['fas', 'bed']" />
                  {{ $t("mip.tabs.overnights") }}
                </span>
              </template>
              <b-row class="mt-3 col-12">
                <b-col class="col-6">
                  <b-row>
                    <b-col v-if="this.indicators.kpis.overnights.evo_real">
                      <SimpleEvoCard :title="$t('indicators.totalOvernights')"
                        :value="this.indicators.kpis.overnights.value" :evoReal="indicators.kpis.overnights.evo_real"
                        :evoPercent="indicators.kpis.overnights.evoPercent" :period_info="$t('dashboard.provenance.caption')" />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mt-3">
                      <ChartCard v-if="this.indicators.repartOvernights.data"
                        :title="$t('indicators.mainProvenancesOvernights')"
                        :options="this.indicators.repartOvernights.options" :data="this.indicators.repartOvernights.data"
                        :chartType="this.indicators.repartOvernights.type" />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="col-lg-6 col-12 mt-3">
                  <b-row>
                    <b-col>
                      <WeekdayChartCard v-if="this.indicators.overnightsWeekday.data"
                        :title="$t('indicators.overnightsByDayOfWeek')"
                        :options="this.indicators.overnightsWeekday.options"
                        :data="this.indicators.overnightsWeekday.data" :chartType="this.indicators.overnightsWeekday.type"
                        defaultIndicator="overnights" />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="col-12">
                <b-col class="col-lg-6 col-12 mt-3" v-if="this.indicators.topCountriesOvernights.table">
                  <TableCard :filter="true" :filter_title="$t('mip.mip_filter_swiss')"
                    :title="this.indicators.topCountriesOvernights.title"
                    :table="this.indicators.topCountriesOvernights.table"
                    :header="this.indicators.topCountriesOvernights.fields" @input="filterCountry" :searchFunction="true"
                    :bubble="this.$t('mip.dataProtection_provenance')" :downloadable="true"
                    @download="ExportProvenances" :period_info="$t('dashboard.provenance.caption')" />
                </b-col>
                <b-col class="col-lg-6 col-12 mt-3" v-if="this.indicators.topCantonsOvernights.table">
                  <TableCard :filter="true" :filter_title="$t('mip.mip_filter_canton')"
                    :title="this.indicators.topCantonsOvernights.title"
                    :table="this.indicators.topCantonsOvernights.table"
                    :header="this.indicators.topCantonsOvernights.fields" :searchFunction="true" @input="filterCanton"
                    :bubble="this.$t('mip.dataProtection_provenance')" :downloadable="true"
                    @download="ExportProvenances" :period_info="$t('dashboard.provenance.caption')" />
                </b-col>
                <b-col class="col-12 mt-3" v-if="this.indicators.topMunicipalitiesOvernights.table">
                  <TableCard :filter="true" :filter_title="$t('mip.mip_filter_canton')"
                    :title="this.indicators.topMunicipalitiesOvernights.title"
                    :table="this.indicators.topMunicipalitiesOvernights.table"
                    :header="this.indicators.topMunicipalitiesOvernights.fields" :searchFunction="true"
                    @input="filterCanton" :period_info="$t('dashboard.provenance.caption')"
                    :downloadable="true" @download="ExportProvenances" :bubble="this.$t('mip.dataProtection_provenance')" />
                </b-col>
              </b-row>
            </b-tab>

            <!-- Map -->
            <b-tab @click="redisplayMap">
              <template #title>
                <span>
                  <font-awesome-icon :icon="['fas', 'map']" />
                  {{ $t("mip.tabs.map") }}
                </span>
              </template>
              <b-row class="mt-3 col-12">
                <MipTerritory v-if="this.map.geojson" :data="this.map.geojson" :key="mapDisplayCount" />
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import MipMixin from "@/mixins/api/mip.js";
import Filters from "@/components/utils/filterbar/Filters.vue";
import MipTerritory from "@/components/maps/MipTerritory";
//import EvoChartCard from "@/components/cards/EvoChartCard/EvoChartCard.vue";
import ChartCard from "@/components/dashboard/ChartCard.vue";
import TableCard from "@/components/dashboard/TableCard";
import WeekdayChartCard from "@/components/dashboard/WeekdayChartCard";
import DetailsTable from "./tabs/DetailsTable.vue";
import MipKPIS from "./tabs/MipKPIS.vue";
import SimpleEvoCard from "@/components/dashboard/SimpleEvoCard.vue";
import ApexFr from 'apexcharts/dist/locales/fr.json';
import ApexDe from 'apexcharts/dist/locales/de.json';
import { mapGetters } from 'vuex';
import moment from "moment";
import PendingRequests from "../../mixins/api/PendingRequests";

export default {
  name: "Details",
  mixins: [MipMixin],
  components: {
    Filters,
    ChartCard,
    TableCard,
    WeekdayChartCard,
    SimpleEvoCard,
    moment,
    MipTerritory,
    DetailsTable,
    MipKPIS
  },
  data() {
    return {
      territoryName: null,
      mapDisplayCount: 0,
      loading: false,
      params: null, // variable to store filter results
      searchDone: false,
      territory_id: 0,
      filter_canton: false,
      filter_country: false,
      visitorsType: "visitors",
      weekdayIndicator: "totalVisitors",
      map: {
        geojson: null,
      },
      defaultValues: {
        period: { start: null, end: null },
        minDate: null,
        maxDate: null,
      },
      dateRange: true,
      indicators: {
        kpis: {
          totalVisitors: {
            value: null,
            evo_real: null,
            evoPercent: null,
            title: this.$t('indicators.totalVisitors'),
            icon: "users",
          },
          overnights: {
            value: null,
            evo_real: null,
            evoPercent: null,
            title: this.$t('indicators.overnights'),
            icon: "bed",
          },
          dayTrippers: {
            value: null,
            evo_real: null,
            evoPercent: null,
            title: this.$t('indicators.dayTrippers'),
            icon: "hiking",
          },
        },
        repartOvernights: {
          data: null,
          type: "donut",
          name: 'repartOvernights',
          options: {
            chart: {
              locales: [ApexDe, ApexFr],
              defaultLocale: this.$i18n.locale == 'de' ? 'de' : 'fr',
              type: "donut",
              height: "400px",
              toolbar: {
                show: true,
                tools: {
                  download: true,
                },
              },
            },
            labels: [this.$t("general.swiss"), this.$t("general.foreigners")],
            plotOptions: {
              pie: {
                donut: {
                  size: "35%",
                },
              },
            },
          },
        },
        overnightsWeekday: {
          data: null,
          type: "bar",
          options: {
            chart: {
              locales: [ApexDe, ApexFr],
              defaultLocale: this.$i18n.locale == 'de' ? 'de' : 'fr',
              id: "stay_duration_overnights",
              type: "bar",
              toolbar: {
                show: true,
                tools: {
                  download: true,
                },
              },
            },
            colors: this.chartColors,
            dataLabels: {
              style: {
                colors: ["#000"],
                fontSize: ".7rem",
              },
            },
            xaxis: {
              categories: [],
            },
            yaxis: {
              title: {
                text: this.$t("legends.overnights"),
              },
            },
          },
        },
        topCountriesOvernights: {
          title: this.$t("indicators.overnightsByCountry"),
          fields: null,
          table: null,
        },
        topCantonsOvernights: {
          title: this.$t("indicators.overnightsByCanton"),
          fields: null,
          table: null,
        },
        topMunicipalitiesOvernights: {
          title: this.$t("indicators.overnightsByMunicipality"),
          fields: null,
          table: null,
          /*map: null,
          mapLegend: this.$t('indicators.overnights'),*/
        },
        female_percent: null,
        male_percent: null,
        kpisTable: {
          items: null,
          displayEvolution: false
        },
        visitorsRepart: {
          data: null,
          type: "donut",
          options: {
            chart: {
              locales: [ApexDe, ApexFr],
              defaultLocale: this.$i18n.locale == 'de' ? 'de' : 'fr',
              type: "donut",
              height: "400px",
              toolbar: {
                show: true,
                tools: {
                  download: true,
                },
              },
            },
            labels: [this.$t("general.swiss"), this.$t("general.foreigners")],
            plotOptions: {
              pie: {
                donut: {
                  size: "35%",
                },
              },
            },
          },
        },
        repartProvenanceMIP: {
          data: null,
          type: "donut",
          options: {
            chart: {
              locales: [ApexDe, ApexFr],
              defaultLocale: this.$i18n.locale == 'de' ? 'de' : 'fr',
              type: "donut",
              height: "100%",
              toolbar: {
                show: true,
                tools: {
                  download: true,
                },
              },
            },
            labels: [this.$t("general.swiss"), this.$t("general.foreigners")],
            plotOptions: {
              pie: {
                donut: {
                  size: "35%",
                },
              },
            },
          },
        },
        repartProvenanceMIPPrev: {
          data: null,
          type: "donut",
          options: {
            chart: {
              locales: [ApexDe, ApexFr],
              defaultLocale: this.$i18n.locale == 'de' ? 'de' : 'fr',
              type: "donut",
              height: "100%",
            },
            labels: [this.$t("general.swiss"), this.$t("general.foreigners")],
            plotOptions: {
              pie: {
                donut: {
                  size: "35%",
                },
              },
            },
          },
        },
        visitors_prev: {
          data: null,
          type: "donut",
          options: {
            chart: {
              locales: [ApexDe, ApexFr],
              defaultLocale: this.$i18n.locale == 'de' ? 'de' : 'fr',
              type: "donut",
              height: "100%",
            },
            labels: [this.$t("general.swiss"), this.$t("general.foreigners")],
            plotOptions: {
              pie: {
                donut: {
                  size: "35%",
                },
              },
            },
          },
        },
        ageGroups: {
          series: [
            {
              name: this.$t("general.age_groups"),
              data: null,
            },
          ],
          chartOptions: {
            chart: {
              height: 350,
              locales: [ApexDe, ApexFr],
              defaultLocale: this.$i18n.locale == 'de' ? 'de' : 'fr',
              id: "age_groups",
              type: "bar",
              toolbar: {
                show: true,
                tools: {
                  download: true,
                },
              },
            },
            colors: null,
            grid: {
              show: false,
            },
            xaxis: {
              categories: [
                this.$t("general.age_groups.group_young"),
                this.$t("general.age_groups.group_20_39"),
                this.$t("general.age_groups.group_40_64"),
                this.$t("general.age_groups.group_old"),
              ],
            },
            dataLabels: {
              enabled: true,
              formatter: function (value) {
                return value + "%";
              },
              offsetY: 45,
              style: {
                colors: ["#000"],
              },
            },
            yaxis: {
              min: 0,
              max: 100,
              tooltip: {
                enabled: false,
              },
              floating: true,
              axisTicks: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              crosshairs: {
                show: false,
              },
              labels: {
                show: false,
              },
            },
            tooltip: {
              enabled: false,
            },
          },
        },
        dayOfWeek: {
          data: null,
          type: "bar",
          options: {
            chart: {
              locales: [ApexDe, ApexFr],
              defaultLocale: this.$i18n.locale == 'de' ? 'de' : 'fr',
              id: "stay_duration",
              type: "bar",
              toolbar: {
                show: true,
                tools: {
                  download: true,
                },
              },
            },
            colors: this.chartColors,
            dataLabels: {
              style: {
                colors: ["#000"],
                fontSize: ".7rem",
              },
            },
            xaxis: {
              categories: [],
            },
            yaxis: {
              title: {
                text: this.$t("legends.visitors"),
              },
            },
          },
        },
        dwellTimes: {
          data: null,
          type: "bar",
          options: {
            chart: {
              locales: [ApexDe, ApexFr],
              defaultLocale: this.$i18n.locale == 'de' ? 'de' : 'fr',
              id: "dwellTimes",
              type: "bar",
              toolbar: {
                show: true,
                tools: {
                  download: true,
                },
              }
            },
            xaxis: {
              categories: [
                "30m - 1h",
                "1h - 2h",
                "2h - 3h",
                "3h - 4h",
                "4h - 5h",
                "5h - 6h",
                "6h - 7h",
                "7h - 8h",
              ],
            },
            colors: this.chartColors,
            yaxis: {
              title: {
                text: this.$t("legends.visitors"),
              },
            },
            dataLabels: {
              style: {
                colors: ["#000"],
                fontSize: ".7rem",
              },
            },
          },
        },
        topFiveCountries: {
          series: [
            { data: null }
          ],
          title: this.$t('indicators.top5Countries'),
          fields: [
            { key: 'market', label: this.$t('general.originMarket') },
            { key: 'visitors', label: this.$t('general.visitors') },
            { key: 'market_share', label: this.$t('general.marketShare') },
          ]
        },
        hourlyVisitors: {
          title: this.$t("indicators.averageHourlyVisitors"),
          type: "bar",
          series: [
            {
              name: this.$t("general.visitors"),
              data: null,
            },
          ],
          chartOptions: {
            chart: {
              locales: [ApexDe, ApexFr],
              defaultLocale: this.$i18n.locale == 'de' ? 'de' : 'fr',
              id: "hourlyVisitors",
              type: "bar",
              toolbar: {
                show: true,
                tools: {
                  download: true,
                },
              },
            },
            xaxis: {
              categories: null,
            },
            dataLabels: {
              enabled: false
            },
            tooltip: {
              x: {
                show: false
              },
              y: {
                formatter: function (value) {
                  // use series argument to pull original string from chart data
                  return value.toLocaleString("fr-CH", { maximumFractionDigits: 0 });
                }
              }
            },
            colors: null,
            yaxis: {
              labels: {
                formatter: (value) => {
                  return value.toLocaleString("fr-CH", { maximumFractionsDigits: 0 });
                },
              }
            }
          },
        },
        topCountries: {
          title: this.$t("indicators.visitorsByCountry"),
          fields: null,
          table: null,
        },
        topCantons: {
          title: this.$t("indicators.visitorsByCanton"),
          fields: null,
          table: null,
        },
        topMunicipalities: {
          title: this.$t("indicators.visitorsByMunicipality"),
          fields: [
            { key: "location", label: this.$t("general.municipality") },
            { key: "visitors", label: this.$t("general.visitors") },
            { key: "market_share", label: this.$t("general.marketShare") },
          ],
          table: null,
          /*map: null,
          mapLegend: this.$t('indicators.totalVisitors')*/
        },
      },
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      // page reload
      window.location.reload();
    },
  },
  methods: {
    async init() {
      // get id from URL
      this.territory_id = this.$route.params.id;
      this.map.geojson = null;
      // empty all indicators
      // this.resetCharts();
      // load period and GeoJson for territory
      await this.latestMIPPeriod();
      await this.loadJsonMap();
      await this.GetTerritoryName();
      this.clearVariables();
    },
    async refresh(params) {
      this.searchDone = true;
      this.loading = true;
      await this.setParams(params);
      await this.wrapperApi();
    },
    setParams(params) {
      this.params = params;
    },
    async setWeekdayIndicator(indicator) {
      this.indicators.dayOfWeek.data = null;
      this.weekdayIndicator = indicator;
      this.getDayOfWeekRepart();
    },
    clearVariables() {
      this.mapDisplayCount = 0;
      this.indicators.female_percent = null;
      this.indicators.male_percent = null;
      this.indicators.ageGroups.series[0].data = null;
      this.indicators.dayOfWeek.data = null;
      this.indicators.dayOfWeek.options.yaxis.title.text = null;
      this.indicators.dayOfWeek.options.xaxis.categories = null;
      this.indicators.overnightsWeekday.options.yaxis.title.text = null;
      this.indicators.overnightsWeekday.options.xaxis.categories = null;
      this.indicators.overnightsWeekday.data = null;
      this.indicators.dwellTimes.data = null;
      this.indicators.topCountries.fields = null;
      this.indicators.topCountries.table = null;
      this.indicators.topCountriesOvernights.fields = null;
      this.indicators.topCountriesOvernights.table = null;
      this.indicators.topCantons.fields = null;
      this.indicators.topCantons.table = null;
      this.indicators.topCantonsOvernights.fields = null;
      this.indicators.topCantonsOvernights.table = null;
      this.indicators.topMunicipalities.fields = null;
      this.indicators.topMunicipalities.table = null;
      this.indicators.topMunicipalitiesOvernights.fields = null;
      this.indicators.topMunicipalitiesOvernights.table = null;
      this.indicators.repartProvenanceMIP.data = null;
      this.indicators.repartProvenanceMIPPrev.data = null;
      this.indicators.repartOvernights.data = null;
      this.indicators.overnightsWeekday.data = null;
      this.indicators.visitorsRepart.data = null;
      this.indicators.kpisTable.items = null;
      this.indicators.visitors_prev.data = null;
      this.indicators.topFiveCountries.series[0].data = null;
      this.indicators.hourlyVisitors.series[0].data = null;
      this.indicators.kpis.totalVisitors.value = null;
      this.indicators.kpis.totalVisitors.evo_real = null;
      this.indicators.kpis.totalVisitors.evoPercent = null;
      this.indicators.kpis.overnights.value = null;
      this.indicators.kpis.overnights.evo_real = null;
      this.indicators.kpis.overnights.evoPercent = null;
      this.indicators.kpis.dayTrippers.value = null;
      this.indicators.kpis.dayTrippers.evo_real = null;
      this.indicators.kpis.dayTrippers.evoPercent = null;
    },
    clearProvenances() {
      this.indicators.topMunicipalities.table = null;
      this.indicators.topCantons.table = null;
      this.indicators.topCountries.table = null;
      this.indicators.topMunicipalitiesOvernights.table = null;
      this.indicators.topCantonsOvernights.table = null;
      this.indicators.topCountriesOvernights.table = null;
    },
    filterCanton(filterValue) {
      this.filter_canton = filterValue;
      //this.clearProvenances();
      this.apiCountriesCalls();
    },
    filterCountry(filterValue) {
      this.filter_country = filterValue;
      //this.clearProvenances();
      this.apiCountriesCalls();
    },
    adaptVisitorsType() {
      this.apiCountriesCalls(false);
    },
    displayModal(modalId) {
      this.$bvModal.show(modalId)
    },
    redisplayMap() {
      this.mapDisplayCount++;
    },
    download() {
      this.exportMipKPIs();
    },
    ExportProvenances() {
      this.exportMipProvenances();
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    countReferenceDays() {
      if (this.params != null) {
        let startDate = moment(this.params.period[0]);
        let endDate = moment(this.params.period[1]);
        return endDate.diff(startDate, 'days') + 1;
      }
      return 0;
    },
    countComparisonDays() {
      if (this.params != null) {
        let startDateComparison = moment(this.params.comparison[0]).subtract(1, 'year');
        let endDateComparison = moment(this.params.comparison[1]).subtract(1, 'year');
        return endDateComparison.diff(startDateComparison, 'days') + 1;
      }
      return 0;
    },
    countReferenceWeekendDays() {
      if (this.params != null) {
        let startDate = moment(this.params.period[0]);
        let endDate = moment(this.params.period[1]);
        let weekendDays = 0;
        for (let m = moment(startDate); m.diff(endDate, 'days') <= 0; m.add(1, 'days')) {
          if (m.isoWeekday() == 6 || m.isoWeekday() == 7) {
            weekendDays++;
          }
        }
        return weekendDays;
      }
      return 0;
    },
    countComparisonWeekendDays() {
      if (this.params != null) {
        let startDateComparison = moment(this.params.comparison[0]).subtract(1, 'year');
        let endDateComparison = moment(this.params.comparison[1]).subtract(1, 'year');
        let weekendDays = 0;
        for (let m = moment(startDateComparison); m.diff(endDateComparison, 'days') <= 0; m.add(1, 'days')) {
          if (m.isoWeekday() == 6 || m.isoWeekday() == 7) {
            weekendDays++;
          }
        }
        return weekendDays;
      }
      return 0;
    },
    formatDateLong(date) {
      if (this.$i18n.locale == "de")
        return moment(date).locale(this.$i18n.locale).format("DD. MMMM YYYY");
      else
        return moment(date).locale(this.$i18n.locale).format("DD MMMM YYYY");
    },
  },
  computed: {
    topFiveCountries: {
      get() {
        return this.indicators.topCountries.table ? this.indicators.topCountries.table.slice(0, 5) : null;
      },
      set() {
        return null;
      }
    },
    startDateText() {
      return moment(this.params.period[0]).format("DD.MM.YYYY");
    },
    endDateText() {
      return moment(this.params.period[1]).format("DD.MM.YYYY");
    },
    exportKPILink() {
      return (
        "https://localhost:44330/api/?&mipId=" +
        this.territory_id +
        "&start=" +
        moment(this.params.period[0]).format("MM-DD-YYYY") +
        "&end=" +
        moment(this.params.period[1]).format("MM-DD-YYYY") +
        "&lang=" +
        this.$i18n.locale
      );
    },
    kpisTableTitle() {
      return this.indicators.kpisTable.displayEvolution ?
        this.$t('indicators.managersKpis') :
        this.$t('indicators.managerKpisNoComparison');
    },
  }
};
</script>
  
<style lang="scss" scoped>
.full-width {
  margin-left: -40px;
  margin-right: -40px;
  margin-top: -40px;
}

.no-header {
  margin-top: -40px;
}

.dropdown-menu {
  z-index: 314159;
}

.gb-flag .gb-flag--default {
  height: 30px !important;
}

#visitorsTypeFilter {

  border-bottom: 1px solid rgba(204, 204, 204, 0.6);

  label {
    margin-left: 1rem;
    margin-right: 2rem;
  }
}

.tab-pane,
.tab-content {
  border: 1px solid #DCDFE6;
  border-top: none;
}
</style>
  